require('./lbUutcMessage.scss');

const lbUutcMessage = angular.module('app.lbUutcMessage', []);

lbUutcMessage.component('lbUutcMessage', {
  controllerAs: 'vm',
  controller: [controller],
  template: require('./lbUutcMessage.html'),
});

function controller() {
  let vm = this;
  vm.message = `Ticket credit should be used before expiration date and is subject to airline fare rules.`;
}

export default lbUutcMessage;



// WEBPACK FOOTER //
// ./src/components/lbUutcMessage/lbUutcMessage.js